module.exports = __webpack_public_path__ + "static/img/top01.b0b756f7.svg";